import chromeExtensionImg from './images/chrome-extension.png';
import clayIntegrationImg from './images/clay-integration.png';
import swarmApiImg from './images/swarm-api.png';
import {Tool} from './types';

export const tools: Tool[] = [
  {
    title: 'Use The Swarm on Linkedin',
    description:
      'Download our free Chrome extension to reveal business email addresses and warm intro paths on LinkedIn.',
    image: chromeExtensionImg,
    links: [
      {
        href: 'https://chromewebstore.google.com/detail/the-swarm/lcjkpibehhcnoniclgodcdmninnmgggi',
        text: 'Get it now',
      },
    ],
  },
  {
    title: 'Clay users:  Connect your Swarm',
    description:
      'Find intro paths to your target accounts on Clay. Add enrichments to your leads, craft and launch intro requests, and more.',
    image: clayIntegrationImg,
    links: [
      {
        href: 'https://www.theswarm.com/solutions/clay',
        text: 'Get started',
      },
      {
        href: 'https://app.theswarm.com/team-settings/api',
        text: 'Get your API key',
      },
    ],
  },
  {
    title: 'Builders: Leverage our API',
    description:
      'Give the power of The Swarm to your users. We built the first-ever Network Mapper API to map and reveal intro paths in any interface.',
    image: swarmApiImg,
    links: [
      {
        href: 'https://docs.theswarm.com/docs/getting-started/introduction',
        text: 'Read the docs',
      },
      {
        href: 'https://app.theswarm.com/team-settings/api',
        text: 'Get your API key',
      },
    ],
  },
];
